import { Component, EventEmitter, Output, ViewChild } from '@angular/core'
import { ModalContainerComponent } from '../../_common/modal-container/modal-container.component'

@Component({
  selector: 'app-modal-product-hs-supplier-confirm',
  templateUrl: './modal-product-hs-supplier-confirm.component.html',
  styleUrls: ['./modal-product-hs-supplier-confirm.component.scss'],
})
export class ModalProductHsSupplierConfirmComponent {
  @ViewChild('modalHsSupplierConfirm') public childModal: ModalContainerComponent
  @Output() onConnect: EventEmitter<any> = new EventEmitter<any>()

  constructor() {}

  public async showChildModal() {
    this.childModal.showChildModal()
  }

  public hideChildModal(): void {
    this.onConnect.emit(false)
    this.childModal.hideChildModal()
  }

  connectHsSupplier() {
    this.onConnect.emit(true)
    this.childModal.hideChildModal()
  }
}
